/**
 * 公允地锁看板组件
 */
import React, { Component } from "react";
import { Row, Spin, Space, Col, Typography, Empty } from "antd";
import Echarts from "echarts";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { queryLockQuantity } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

const { Text } = Typography;

const FIXED_MACARON_COLORS = [
  "#9B7AE8",
  "#F56C6C",
  "#F5C842",
  "#67C23A",
  "#409EFF",
  "#FFF5A0",
  "#D4A5C0",
];

@connect((state) => state)
class GroundLockBoard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    const param = this.props.param || {};
    this.state = {
      loading: true,
      totalNum: 0,
      yoyRate: "+15.6%",
      param: {
        cityIds: param.cityIds || "",
        // provinceIds: param.provinceIds || "000000",
        // date: param.date || "",
        // isMonth: param.isMonth || 2,
        // operationProperty: param.operationProperty || "3",
        // operationMode: param.operationMode || "",
      },
      // 地锁状态数据
      lockStatusData: [
        { name: "已升起", value: 8157, color: "#9B7AE8" },
        { name: "已降下", value: 6325, color: "#F56C6C" },
        { name: "已锁车", value: 5295, color: "#F5C842" },
        { name: "已休眠", value: 4729, color: "#67C23A" },
        { name: "故障", value: 57, color: "#D9D9D9" },
        { name: "离网", value: 25, color: "#409EFF" },
        { name: "未知", value: 5, color: "#FFF5A0" },
      ],
      noData: false,
    };
  }

  // // 页面加载前方法
  // componentWillMount() {
  //   this.getLockQuantity();
  // }

  //工具函数：生成单个随机马卡龙色
  getRandomMacaronColor() {
    const h = Math.floor(Math.random() * 360);
    const s = Math.floor(Math.random() * 20) + 20; // 低饱和度
    const l = Math.floor(Math.random() * 20) + 70; // 高亮度
    return `hsl(${h}, ${s}%, ${l}%)`;
  }
  //优先固定色，不足自动补随机色
  getFinalColors(dataLength) {
    // 先打乱固定色板（避免每次颜色顺序一样）
    const shuffledFixed = [...FIXED_MACARON_COLORS].sort(() => Math.random() - 0.5);

    // 情况1：数据长度 ≤ 固定色数量 → 直接用固定色
    if (dataLength <= shuffledFixed.length) {
      return shuffledFixed.slice(0, dataLength);
    }

    // 情况2：数据更长 → 固定色用完 + 剩余部分生成随机色
    const randomColors = Array.from(
      { length: dataLength - shuffledFixed.length },
      this.getRandomMacaronColor,
    );
    return [...shuffledFixed, ...randomColors];
  }

  getLockQuantity() {
    fetchHandler(queryLockQuantity, {
      // startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      // isMonth: this.state.param.isMonth,
      stubType: this.state.param.stubType,
      operationMode: this.state.param.operationMode,
      // operationProperty: "3",
      // provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        const lockStatusNumDTOList = res.data.lockStatusNumDTOList;
        // lockStatusNumDTOList为null时，设置lockStatusData为空数组，并标记noData为true
        if (lockStatusNumDTOList === null) {
          this.setState({
            lockStatusData: [],
            totalNum: res.data.totalNum,
            noData: true,
          });
          return;
        }
        // 为每个数据项添加颜色属性，确保饼图和图例颜色一致
        const colors = this.getFinalColors(lockStatusNumDTOList.length);
        const dataWithColor = lockStatusNumDTOList.map((item, index) => ({
          ...item,
          color: colors[index],
        }));
        this.setState({
          lockStatusData: dataWithColor,
          totalNum: res.data.totalNum,
          noData: false,
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps****nextProps", nextProps);

    const nextParam = nextProps.param || {};
    const currentParam = this.state.param || {};
    if (
      nextParam.provinceIds === currentParam.provinceIds &&
      nextParam.cityIds === currentParam.cityIds &&
      nextParam.stubType === currentParam.stubType &&
      // nextParam.isMonth === currentParam.isMonth &&
      // nextParam.operationProperty === currentParam.operationProperty &&
      nextParam.operationMode === currentParam.operationMode
      // nextParam.date === currentParam.date
    ) {
      return;
    }
    this.setState(
      {
        param: {
          // isMonth: nextParam.isMonth || 2,
          cityIds: nextParam.cityIds || "",
          // provinceIds: nextParam.provinceIds || "000000",
          // date: nextParam.date || "",
          // operationProperty: nextParam.operationProperty || "3",
          operationMode: nextParam.operationMode || void 0,
          stubType: nextParam.stubType || void 0,
        },
        loading: true,
      },
      () => {
        this.fetchData();
      },
    );
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.lockStatusData !== this.state.lockStatusData) {
      this.renderChart();
    }
  }

  fetchData() {
    // 模拟数据，实际项目中应该调用接口
    setTimeout(() => {
      this.setState(
        {
          loading: false,
        },
        () => {
          this.renderChart();
        },
      );
    }, 500);
    this.getLockQuantity();
  }

  renderChart() {
    const chartDom = document.getElementById("groundLockPieChart");
    if (!chartDom) return;

    const myChart = Echarts.init(chartDom);
    const { lockStatusData } = this.state;

    const data = lockStatusData.map((item) => ({
      name: item.lockStatusName,
      value: item.percent,
      ratio: item.percent,
      num: item.num,
    }));
    console.log("data****", data);

    const option = {
      tooltip: {
        trigger: "item",
        formatter: (params) => {
          return `${params.name}<br/>共${params.data.num}个<br/>占比：${params.data.ratio}%`;
        },
      },
      series: [
        {
          type: "pie",
          roseType: "radius",
          radius: ["10%", "65%"],
          center: ["50%", "50%"],
          minRadius: 20,
          minAngle: 10,
          silent: false,
          itemStyle: {
            borderRadius: 5,
          },
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: true,
              position: "outside",
              fontSize: 10,
              color: "#333",
              formatter: "{b}",
              avoidLabelOverlap: true,
              whiteSpace: "nowrap",
              overflow: "none",
              ellipsis: false,
              alignTo: "labelLine",
              padding: [0, 0, 0, 0],
            },
          },
          data: data,
          color: lockStatusData.map((item) => item.color),
        },
      ],
    };

    myChart.setOption(option);

    window.addEventListener("resize", () => {
      myChart.resize();
    });
  }

  openLockDetail = () => {
    this.props.openTab(
      {},
      {
        key: "0107",
        titleText: "地锁查询",
      },
    );
  };

  render() {
    const { loading, totalNum, lockStatusData, noData } = this.state;

    return (
      <Spin spinning={loading}>
        <Row className="ground-lock-board" style={{ display: "flex", alignItems: "center" }}>
          {/* 左侧统计 */}
          <Col span={6}>
            <Row>
              <Col span={10} style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    backgroundColor: "#E6F7F5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "12px 0px",
                  }}>
                  <svg viewBox="0 0 24 24" width="40" height="40" fill="#13C2C2">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                  </svg>
                </div>
              </Col>
              <Col span={12}>
                <Space direction="vertical" style={{ margin: "24px 0px" }}>
                  <div style={{ fontSize: "22px", color: "#666" }}>
                    地锁数(个)
                    <a
                      style={{ fontSize: "14px", marginLeft: "8px", color: "#5584FF" }}
                      onClick={this.openLockDetail}>
                      详情&gt;
                    </a>
                  </div>
                  <div
                    style={{
                      fontSize: "36px",
                      fontWeight: "bold",
                      color: "#333",
                    }}>
                    {totalNum}
                  </div>
                </Space>
              </Col>
            </Row>
          </Col>

          {/* 中间饼图和右侧图例 */}
          {noData ? (
            <Col
              span={18}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px",
              }}>
              <Empty description="暂无相关地锁数据" />
            </Col>
          ) : (
            <React.Fragment>
              <Col
                className="center-chart"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 20px",
                }}>
                <div id="groundLockPieChart" style={{ width: "220px", height: "220px" }} />
                <div style={{ fontSize: "16px", color: "#999", fontWeight: "bold" }}>地锁状态</div>
              </Col>
              <Col
                className="right-legend"
                style={{
                  width: "380px",
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  maxHeight: "150px",
                }}>
                {lockStatusData.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      width: 180,
                    }}>
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        marginRight: "10px",
                        border: "4px solid " + item.color,
                      }}
                    />
                    <span style={{ fontSize: "16px", color: "#666", flex: 1 }}>
                      {item.lockStatusName}
                    </span>
                    <span style={{ fontSize: "16px", color: "#333", fontWeight: "500" }}>
                      {item.percent}%
                    </span>
                  </div>
                ))}
              </Col>
            </React.Fragment>
          )}
        </Row>
      </Spin>
    );
  }
}

export default injectIntl(GroundLockBoard);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/groundLockBoard.js